import React from 'react';
import Color from 'color';
import { translate } from 'react-i18next';
import { Form, Image, Input, Header, Button, Container, Grid, Message } from 'semantic-ui-react';
import DayPickerInput from 'react-day-picker/DayPickerInput'
import MomentLocaleUtils from 'react-day-picker/moment';
import YearMonthForm from 'modules/misc/YearMonthForm.js';
import UserUtils from 'utils/UserUtils.js';

import {colors, fontSizes, fonts, spacings, shadow} from 'style';

var style= {
    container: {
        height:'100%', 
        padding:'10px 10px 100px 10px',
        textAlign: 'center',
        ...fonts.body,
        lineHeight: '1.5',
    },
    containerDiv: {
        height:'100%', 
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: '40rem',
    },
    segment: {
        height: '100%',
        textAlign: 'center',
    },
    datePickerInput: {
        width: '100%'
    },
    button: {
        fontWeight: 'normal',
        ...fonts.body,
        lineHeight: '1.5',
        borderRadius: '100px',
        backgroundColor: colors.themeTeal,
        color: '#fff',
        width: '330px',
        boxShadow: shadow,
    },
    message: {
        display: 'inline-block',
        fontWeight: 'normal',
        ...fonts.body,
        lineHeight: '1.5',
        borderRadius: '100px',
        backgroundColor: colors.themeBlue,
        color: '#fff',
        width: '330px',
        boxShadow: 'none',
        padding: '.78571429em 1.5em .78571429em',
    },
    inputLabel: {
        paddingTop: '10px',
        textAlign: 'left',
        color: colors.themeDarkerGrey,
        ...fonts.body,
    },
    input: {
        width: '100%',
        paddingLeft: '0px',
        borderTop: 'none',
        borderRight: 'none',
        borderLeft: 'none',
        borderBottom: '1px solid ' + colors.themeTeal,
        color: colors.themeTeal,
        boxShadow: 'none',
        borderRadius: '0',
        ...fonts.body,
    },
    avatarContainer: {
        position: 'relative',
        display: 'inline-block',
        minHeight: '150px',
        paddingBottom: spacings.small,
    },
    avatar: {
        width: '250px',
        borderRadius: '50%',
        cursor: 'pointer',
        border: '5px solid ' + colors.themeTeal,
        boxShadow: shadow,
    },
    avatarPlaceholder: {
        height: '250px',
        backgroundColor: Color(colors.themeBlue).alpha(0.25).string(),
    },
    grid: {
        backgroundColor: 'white',
    },
    addPhoto: {
        pointerEvents: 'none',
        width: '140px',
        position: 'absolute',
        top: '65px',
        left: '50%',
        marginLeft: '-70px',
        color: colors.themeBlue,
        lineHeight: '1',
    },
    addPhotoIcon: {
        fontSize: '85px',
    },
    addPhotoText: {
        fontSize: fontSizes.body,
    },
};

const UserEdit = ({t,
                   userProfile, 
                   latestUserProfile,
                   valid, 
                   error, 
                   busy, 
                   complete, 
                   onSave,
                   onChange,
                   onChangeBirthDate,
                   onChangeBirthDateText,
                   onShowChoosePhoto, 
                   format,
                   birthDate,
                   initialMonthYear,
                   excludeDOB,
                   buttonText,
                   children}) => (
        <Container style={style.container}>
            <Form style={style.containerDiv} onSubmit={e => {e.preventDefault(); onSave();}} autoComplete='off'>
            <div style={style.segment}>
                <Grid style={style.grid} centered columns={1}>
                    <Grid.Row verticalAlign='middle'>
                        <Grid.Column verticalAlign='middle'>
                            <span style={style.avatarContainer}>
                                {UserUtils.hasAvatar(latestUserProfile) ? (
                                        <Image style={style.avatar} src={UserUtils.getAvatarURL(latestUserProfile)} onClick={onShowChoosePhoto}/>
                                    ) : (
                                        <div style={{...style.avatar, ...style.avatarPlaceholder}} onClick={onShowChoosePhoto}></div>
                                    )
                                }
                                {!UserUtils.hasAvatar(latestUserProfile) &&
                                    <div style={style.addPhoto}>
                                        <i style={style.addPhotoIcon} className='icon-add' />
                                        <div style={style.addPhotoText}>{t('Add Photo')}</div>
                                    </div>
                                }
                            </span>
                            <div style={style.inputLabel}>{t('First Name')}</div>
                            <Form.Field>        
                                <input style={style.input} name='userProfile.firstName' value={userProfile.firstName || ''} onChange={onChange} /><br/>
                            </Form.Field>        
                            <div style={style.inputLabel}>{t('Last Name')}</div>
                            <Form.Field>        
                            <input style={style.input} name='userProfile.lastName' value={userProfile.lastName || ''}  onChange={onChange} /><br/>
                            </Form.Field>        

                            {!excludeDOB &&
                            <div style={style.inputLabel}>{t('Date of Birth')}</div>
                            }
                            {!excludeDOB &&
                            <Form.Field>        
                                <DayPickerInput
                                      style={style.input}
                                      classNames={{container:"DayPickerInput full-width", 
                                                   overlay:"DayPickerInput-Overlay",
                                                   overlayWrapper:"DayPickerInput-OverlayWrapper"}}
                                      name="userProfile.birthDate"
                                      placeholder={format}
                                      format={format}
                                      value={birthDate || ''}
                                      onDayChange={onChangeBirthDate}
                                      onChange={onChangeBirthDateText}
                                      dayPickerProps={{locale:localStorage.i18nextLng,
                                                       localeUtils:MomentLocaleUtils,
                                                       captionElement:<YearMonthForm onChange={onChangeBirthDate}/>,
                                                       month:YearMonthForm.fromMonth,
                                                       initialMonth:initialMonthYear,
                                                       disabledDays:[{ after: (new Date()) }] 
                                                        }}
                                       /> 
                            </Form.Field>  
                            }
                            <br />
                            {!complete ?
                                <Button type="button" style={style.button} onClick={onSave} loading={busy} disabled={!valid || error}  positive>{buttonText || t('Save')}</Button>
                              : <div style={style.message}>{t('Saved')}</div>
                            }

                            {error &&
                            <Message negative>
                                <Message.Header>{t('Error')}</Message.Header>
                                <p>{error}</p>
                            </Message>
                            }
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
            <input style={{display:'none'}} type="submit" />
        </Form>
        {children}
        </Container>
);

export default translate('profile')(UserEdit);



// WEBPACK FOOTER //
// ./src/modules/profile/UserEdit.js